import styles from '@/styles/variables.scss'
const { ds, dh, stripeBgC, stripeInnerBorderC, normalC } = styles

const state = {
  patientName: '',
  zoomRatio: 1,
  body21CmRatio: 1,
  rrefresh: 1,
  cmin: 3.9,
  cmax: 10,
  bigDosageTypeColors: ['#5578e0', '#8855e0', '#18d9b9'], // 分别对应type: 0, 1(延长), 2(双波)
  bigDosageTypeColorsLinear: [{ r: '85', g: '120', b: '224' }, { r: '136', g: '85', b: '224' }, { r: '24', g: '217', b: '185' }], // 分别对应type: 0, 1(延长), 2(双波)
  cminC: '#ff0000',
  // cminC: '#e15d4d',
  cmaxC: '#ffaf00',
  // cmaxC: '#F0BE5B',
  // basalC: '#2D00FF', // 基础率颜色
  basalC: '#58c3ed', // 基础率颜色: #58c3ed,透明度0.2
  basalBorderC: '#7dd7fb', // 基础率边界线颜色
  bigDosageC: '#26FF49', // 大剂量颜色
  normalC,
  lfs: 12, // label 字体大小
  lfw: 500, // label font-weight
  lang: 'en',
  unit: 'mmol/L', // 还有mg/dL的单位
  hourFormat: '24',
  ds, dh, stripeBgC, stripeInnerBorderC
}

const mutations = {
  UPDATE_HIGH_LOW_LIMIT: (state, limit = {}) => {
    const { high, low } = limit
    if (!low) {
      console.error(`[UPDATE_HIGH_LOW_LIMIT]入参低血糖阈值不合法，使用默认3.9`)
    }
    if (!high) {
      console.error(`[UPDATE_HIGH_LOW_LIMIT]入参高血糖阈值不合法，使用默认10`)
    }

    /* eslint-disable */
    const isMg = state.unit && /mg/i.test(state.unit)
    const fixNum = isMg ? 0 : 1
    
    state.cmin = +((low ? low : 3.9).toFixed(fixNum))
    state.cmax = +((high ? high : 10).toFixed(fixNum))
    /* eslint-enable */
  },
  UPDATE_A4SIZE_RATIO: (state, nds) => {
    // const { ds, dh } = state
    // const ratio = dh / ds
    // const ndh = nds * ratio

    // state.ds = Math.floor(nds)
    // state.ndh = Math.floor(ndh)
    const { w: cmw, bw } = nds
    const w = 29.7 * cmw // a4 size
    state.zoomRatio = !w ? 1 : (w / ds)
    const buffer = 0.1
    state.body21CmRatio = !w ? (1 - buffer) : ((bw / w) ? (bw / w * (1 - buffer)) : (1 - buffer))
    
    console.error(`UPDATE_A4SIZE_RATIO, ${state.zoomRatio}, ds: ${ds}, buffer: ${buffer}, bw: ${bw}, w: ${w}, cmw: ${cmw}`)
  },
  NOTIFY_REDRAW: (state) => {
    state.rrefresh++
  },
  CHANGE_PATIENTNAME: (state, name) => {
    state.patientName = name
  },
  CHANGE_LANG: (state, lang) => {
    state.lang = lang
  },
  CHANGE_UNIT: (state, unit) => {
    // console.error(`CHANGE_UNIT, unit: ${unit}`)
    state.unit = unit
  },
  CHANGE_HOURFORMAT: (state, format) => {
    state.hourFormat = format
  },
  MODIFY_GLULIMITS: (state, extra) => {
    let cmin = extra.min || extra.cmin || 3.9
    let cmax = extra.max || extra.cmax || 10
    const isMg = state.unit && /mg/i.test(state.unit)
    const fixNum = isMg ? 0 : 1
    cmin = +((+cmin).toFixed(fixNum))
    cmax = +((+cmax).toFixed(fixNum))
    Object.assign(state, {
      cmin,
      cmax 
    })
  }
}

const actions = {
  updateHighAndLowLimit({ commit }, nds) {
    commit('UPDATE_HIGH_LOW_LIMIT', nds)
  },
  updateA4SizeRatio({ commit }, { w, bw }) {
    console.error(`a4实际宽大小(像素): ${w}, 1cm width: ${bw}`)
    commit('UPDATE_A4SIZE_RATIO', { w, bw })
  },
  notifyReDraw({ commit }, data) {
    console.error(`notify redraw`)
    commit('NOTIFY_REDRAW')
  },
  updateGlucoseLimits({ commit }, data) {
    commit('MODIFY_GLULIMITS', data)
  },
  updateUnit({ commit }, unit) {
    if (/mmol/i.test(`${unit}`)) {
      commit('CHANGE_UNIT', 'mmol/L')
    } else {
      commit('CHANGE_UNIT', 'mg/dL')
    }
  },
  updateHourformat({ commit }, hourformat) {
    commit('CHANGE_HOURFORMAT', hourformat)
  },
  updateLang({ commit }, lang) {
    commit('CHANGE_LANG', lang)
  },
  updateName({ commit }, name) {
    commit('CHANGE_PATIENTNAME', name)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
